import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Datafield } from 'src/app/models/database/datafield.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';
import { DatafieldAttributes, DatasheetService } from 'src/app/services/datasheet/datasheet.service';
import { DatafieldsEnum } from '../datafield.enum';
import { IDatafieldComponent } from '../datafield.interface';

@Component({
  selector: 'app-datafield-range',
  templateUrl: './datafield-range.component.html',
  styleUrls: ['./datafield-range.component.scss']
})
export class DatafieldRangeComponent implements OnInit, OnDestroy, IDatafieldComponent {

  maxValue: number
  minValue: number
  datafieldRangeValue: number
  label: string
  session: string
  value: any
  datafield: Datafield
  subscriptionManager: Subscription = new Subscription()

  constructor(
    private datasheetService: DatasheetService,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngOnInit(): void {
    if (this.value) {
      this.datafieldRangeValue = this.value
    }
    this.subscriptionManager.add(this.datasheetService.datasheetObjectBuilder$.pipe(
      tap(() => {
        const datafieldAttributes: DatafieldAttributes =
          new DatafieldAttributes(DatafieldsEnum.RANGE, this.label, this.datafieldRangeValue)
        this.datasheetService.buildDatasheetObject(this.session, datafieldAttributes)
      })
    ).subscribe())
    this.datafieldRangeValue = this.minValue
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe()
  }
}
